import React from "react";
import Header from "../../Components/Header";
import "./Home.scss"
import Slider from "./Slider/Slider";
import First from "./First";
import Second from "./Second";
import Third from "./Third";
import Fourth from "./Fourth";
import Fifth from "./Fifth";
import Footer from "../Footer";
import LinkedinTestimonial from "./linked/LinkedinTestmonial";

const Home = (props) =>{
    console.log("Home data",props);

    console.log("first",props.data.feedbackForm.First[0]);

    let cards = props?.data?.cards;

    // console.log(cards);
    let homedata = props?.data?.home;
    let feedbackformdata = props?.data?.feedbackForm;
    // console.log(homedata);
    let first = feedbackformdata?.First[0];
    let third = feedbackformdata?.Third;
    let fourth = feedbackformdata?.Fourth;
    let fifth = feedbackformdata?.Fifth;
    let second = feedbackformdata?.Second;

    let fifthdata = {
        pagedata : fifth,
        cards: cards
    };
    
    console.log(fifth);
    
    return(
        <div className="Home">
            <Header/>
            {/* <Slider/>
            <LinkedinTestimonial/> */}
            <First data = {first}/>
            <Second data = {second}/>
            <Third data = {third} />
            <Fourth data = {fourth}/>
            <Fifth data = {fifthdata}/>
            <Footer/>
        </div>
    )
}

export default Home